import React, { useContext, useEffect, useState } from 'react';
import { Spin, Transfer } from 'antd';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import system from "../../../../config/systematic";
import fetchApi from '../../../../utils/api/fetchApi';
import antMessage from '../../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../../App';
// 引入拼音库
import { pinyin } from 'pinyin-pro';
const InventoryToEstimate = (props: any) => {
    /**后端数据wmService */
    const wmService = system.wmService;
    const { data, closeModal, modalTitle } = props;
    const [keys, setKeys] = useState<any>([]);
       
    const [allKeys, setAllKeys] = useState<any>([]);

    const [leftInitKeys, setLeftInitKeys] = useState<Array<any>>([]);
    const [rightInitKeys, setRightInitKeys] = useState<Array<any>>([]);

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    const [loadingData, setLoadingData] = useState<any>(false);
    const [rows, setRows] = useState<Array<any>>([]);
    
    useEffect(() => {
        getDataBaseData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDataBaseData = () => {

        fetchApi.GET(wmService, {
            apiId: data.apiId,
            apiExtend: data.apiExtend,
            apiData:{
                branchStoreId:contextData?.currentBranchStoreId,
                mountDataOptions:{
                    userMount:{
                       isDept:true,
                    }
               },
            }
        }).then(res => {
            if (res.success) {
                //目标数据的keys数组
                const targetKeys = [];
                //待沽清数据
                const noEstimateData = [];
                //左边数据keys数组;
                const leftKeys = [];
                //所有key值
                const allKeys = [];
                for (let j = 0; j < res.data.length; j++) {
                    
                    allKeys.push(res.data[j].id)
                    const newData = {
                        ...data[j],
                        key: res.data[j].id.toString(),
                        id: res.data[j].id,
                        status: "origin",
                        direction: "left",
                        [data.name]: res.data[j][data.name],
                        chosen: res.data[j].isMenu,
                        shopTypeName:res.data[j].shopTypeName
                    };
                    if (newData.chosen) {
                        newData.direction = "right"
                        targetKeys.push(newData.key);
                    } else {
                        leftKeys.push(newData.key)
                    }
                    noEstimateData.push(newData);
                }
                
                setAllKeys(allKeys)
                setKeys(targetKeys);
                setRows(noEstimateData)
                setRightInitKeys(targetKeys)
                setLeftInitKeys(leftKeys)
                // setData(newFoodWarehouseData);
            }
        });
    }


    const handleOk = async (e: any) => {
        setLoadingData(true);
        let keys = rows.filter((item) => item.status === "update" && item.direction === "right");
        let leftKeys = rows.filter((item) => item.status === "update" && item.direction === "left");
        // let leftKeys = allKeys.filter((item: any) => !keys.includes(item));
        fetchApi.POST(wmService, {
            apiId: data.apiId,
            apiExtend: "estimateHandle",
            apiData: {
                keys,
                leftKeys,
                // tableName:data.name,
                branchStoreId: contextData?.currentBranchStoreId,
                mountDataOptions:{
                    userMount: {
                        isDept: true,
                        isUserLogin:true
                      }
                }
            }
        }).then((res) => {
            setLoadingData(false)
            closeModal(true)

        }
        ).catch((err) => {
            setLoadingData(false)
        })
    };

    // /**关闭窗口并刷新数据 */
    // const handleCancel = (status: Boolean) => {
    //     closeModal(false)
    //     if (status === true) {
    //         getData(true);
    //     }
    // }

    const onChange = (keys: any, direction: any, moveKeys: any) => {
        let newArray = rows.map(item => {
            if (direction === "left") {
                if (moveKeys.includes(item.id)) {
                    if (leftInitKeys.includes(item.id)) {
                        return { ...item, direction, status: "origin" };
                    } else {
                        return { ...item, direction, status: "update" };
                    }
                } else {
                    return {
                        ...item
                    };
                }
            }
            if (direction === "right") {
                if (moveKeys.includes(item.id)) {
                    if (rightInitKeys.includes(item.id)) {
                        return { ...item, direction, status: "origin" };
                    } else {
                        return { ...item, direction, status: "update" };
                    }
                } else {
                    return {
                        ...item
                    };
                }
            }
        });
        setRows(newArray)
        setKeys(keys);

    };

const handleFilterOption = (inputValue: string, option: any) => {
  // 1. 获取当前项的显示文本（对应 render 里的 item[data.name]）
  // 注意：这里假设 option 是你 dataSource 里的原始对象，包含 name 字段
  let otherName=option.shopTypeName
  
  let itemName = option[data.name]; 

  if(otherName){
      itemName+=itemName+otherName
  }

  
  // 2. 将中文转换为无间隔的拼音首字母（例如："膏蟹" -> "gx"）
  // 如果你的中文在 item 里叫别的名字，请替换 itemName
  const pinyinInitials = pinyin(itemName, { pattern: 'initial', type: 'array' }).join('').toLowerCase();
 
  // 3. 判断逻辑
  const lowerInput = inputValue.toLowerCase();
  
  // 条件A：中文名包含输入（忽略大小写）
  const matchChinese = itemName.toLowerCase().includes(lowerInput);
  
  // 条件B：拼音首字母包含输入（忽略大小写，支持 gx, GX, gX）
  const matchPinyin = pinyinInitials.includes(lowerInput);

  return matchChinese || matchPinyin;
};
    return (
        <>
            <AntDraggableModal
                title={modalTitle}
                open={true}
                okText='确定'
                cancelText='取消'
                cancelButtonProps={{ disabled: loadingData }}
                okButtonProps={{ disabled: loadingData }}
                onOk={handleOk}
                onCancel={() => closeModal(false)}
                closable={false}
                maskClosable={false}
                confirmLoading={loadingData}
                width={700}
            >
                <Transfer
                filterOption={handleFilterOption}
                    dataSource={rows}
                    titles={data.transferTitle}
                    showSearch
                    listStyle={{ width: 400 }}
                    targetKeys={keys}
                    onChange={onChange}
                    render={item => `${item[data.name]}`}
                    pagination
                />
            </AntDraggableModal>
        </>
    );
};

export default InventoryToEstimate;